export default "__VITE_ASSET__CJm9bXeo__"